import { MASSIVE_MESSAGE_TITLE } from 'app-constants'

export function getMassiveMessage(virtualSupportMassive) {
  const { message, isMassive } = virtualSupportMassive

  return { title: MASSIVE_MESSAGE_TITLE, description: message, isMassive, isWarning: true }
}
